import { createNavigationContainerRef, getStateFromPath } from '@react-navigation/native';

import { NavigationLinking } from './NavConfigForLinking';
import { RootNavigationParamList } from 'src/core/types/RootNavigationParamList';

export const rootNavigationRef = createNavigationContainerRef<RootNavigationParamList>();

let pendingNotificationUrl: string | undefined;
let canOpenLoggedInRoutes = false;

const trimLeadingSlash = (path: string) => path.replace(/^\/+/, '');

const getPathFromUrl = (url: string): string => {
  const matchingPrefix = NavigationLinking.prefixes
    .filter((prefix): prefix is string => typeof prefix === 'string')
    .find((prefix) => url.startsWith(prefix));

  if (matchingPrefix) {
    return trimLeadingSlash(url.slice(matchingPrefix.length));
  }

  try {
    const parsedUrl = new URL(url);
    return trimLeadingSlash(`${parsedUrl.pathname}${parsedUrl.search}`);
  } catch {
    return trimLeadingSlash(url);
  }
};

export const openNotificationUrl = (url?: string) => {
  pendingNotificationUrl = url || 'Notifications';
  flushPendingNotificationUrl();
};

export const setNotificationNavigationReady = (isLoggedIn: boolean) => {
  canOpenLoggedInRoutes = isLoggedIn;
  flushPendingNotificationUrl();
};

export const flushPendingNotificationUrl = () => {
  if (!pendingNotificationUrl || !canOpenLoggedInRoutes || !rootNavigationRef.isReady()) {
    return;
  }

  const url = pendingNotificationUrl;
  const path = getPathFromUrl(url);
  const state = getStateFromPath(path, NavigationLinking.config);

  pendingNotificationUrl = undefined;

  if (state) {
    rootNavigationRef.resetRoot(state);
    return;
  }

  rootNavigationRef.navigate('Notifications');
};
